import React from "react";
import { Alert, Divider, Box, Typography, Grid } from "@common-ui/ui";

const Instruction = ({
  section,
  sectionItem,
  sectionId,
  sectionItemIndex,
  sectionStep,
  step,
  handleRemoveSectionItem,
  subSectionStep,
  subSectionId,
}) => {
  let subSection;
  if (subSectionId) {
    subSection = section.items.find((section) => section.id === subSectionId);
  }

  const getStep = (id) => {
    if (subSection) {
      return `${subSectionStep}.${
        Array.from(subSection.steps).indexOf(id) + 1
      }`;
    }
    return Array.from(section.steps).indexOf(id) + 1;
  };
  return (
    <div>
      <Grid container spacing={2}>
        <Grid item md={1} xs={12}>
          <span style={{ display: "flex", alignItems: "center" }}>
            <Typography
              fontWeight="700"
              sx={{ mr: 1 }}
            >{`${sectionStep}.${getStep(sectionItem.id)}`}</Typography>
          </span>
        </Grid>
        <Grid item md={12} xs={12}>
          {sectionItem.infoPanel === "Information" ? (
            <Alert sx={{ my: 2 }} severity="info">
              <Typography>{sectionItem.content}</Typography>
            </Alert>
          ) : sectionItem.infoPanel === "Warning" ? (
            <Alert sx={{ my: 2 }} severity="warning">
              <Typography>{sectionItem.content}</Typography>
            </Alert>
          ) : sectionItem.infoPanel === "Danger" ? (
            <Alert sx={{ my: 2 }} severity="error">
              <Typography>{sectionItem.content}</Typography>
            </Alert>
          ) : (
            <Box sx={{ my: 1 }}>
              <Typography>{sectionItem.content}</Typography>
            </Box>
          )}
          {/* <div>{<InfoPanel key={sectionItem.infoPanel} />}</div> */}
        </Grid>
      </Grid>
      {/* <div>Coming Soon!</div>  */}
      <Divider sx={{ my: 2 }} />
    </div>
  );
};

export default Instruction;
